import React from "react";
import { Route, Routes } from "react-router-dom";
import IndexGeneralMasters from './IndexGeneralMasters';
import { guardElement } from "@comps/components";

const GeneralMasterModules = () => {
  return (
    <Routes>
      <Route path="/" element={ guardElement(<IndexGeneralMasters modkey="generalMasters" />, "generalMasters") } />

    </Routes>
  );
}

export default GeneralMasterModules;
